import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=46a6e058&scoped=true"
import script from "./PageTitle.vue?vue&type=script&lang=js"
export * from "./PageTitle.vue?vue&type=script&lang=js"
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=46a6e058&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a6e058",
  null
  
)

export default component.exports